import { required } from 'vuelidate/lib/validators';

import BaseValidation from '../../../Validations/BaseValidation';

export const names = {
  Message: 'Message',
};

export default (path: string = '') =>
  new BaseValidation(
    [
      {
        name: names.Message,
        rules: { required },
        messages: {
          required: 'Enter a message',
        },
      },
    ],
    path,
  );
